import { api } from "@/lib/api";

export const productsApi = {
  meta: () => api.get("/products/meta").then((r) => r.data),
  stats: () => api.get("/products/stats").then((r) => r.data),
  list: (params) => api.get("/products", { params }).then((r) => r.data),
  get: (id) => api.get(`/products/${id}`).then((r) => r.data),
  create: (body) => api.post("/products", body).then((r) => r.data),
  update: (id, body) => api.put(`/products/${id}`, body).then((r) => r.data),
  setStatus: (id, is_active) => api.patch(`/products/${id}/status`, { is_active }).then((r) => r.data),
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
